import { memo } from 'react'
import styled from 'styled-components'
import { createUnderline, mq, presets, vw } from '@/styles'
import { TypeTel } from './ContactUs'
import { LANG } from '@/utils'

const CONTACT_INFO = {
  en: {
    email: 'mailto:hello@hellomamma.co.uk',
    tel: { href: '4407946173345', text: '07946 173345' }
  },
  es: {
    email: 'mailto:hola@hellomamma.eu',
    tel: { href: '34933037615', text: '+34 93 303 76 15' }
  },
  fr: {
    email: 'mailto:commandes@hellomamma.eu',
    tel: { href: null, text: null }
  },
  it: {
    email: 'mailto:hola@hellomamma.eu',
    tel: { href: '34933037615', text: '+34 93 303 76 15' }
  }
} as const

const CALL_US_TRANSLATIONS = {
  en: (_email: string, tel: TypeTel) =>
    `Do you have any question?<br />Don't worry about it, contact us at <a href="https://wa.me/${tel.href}" class="en">${tel.text}<span></span></a>`,

  es: (email: string, _tel: TypeTel) =>
    `¿Tienes preguntas?<br />Non ti preoccupare, <a href="${email}" class="es">¡escríbenos!<span></span></a>`,

  fr: (email: string, _tel: TypeTel) =>
    `Des questions ?<br />Non ti preoccupare, <a href="${email}" class="fr">écris-nous !<span></span></a>`,

  it: (email: string, _tel: TypeTel) =>
    `Hai dubbi?<br />Non ti preoccupare, <a href="${email}" class="it">scrivici!<span></span></a>`
} as const

export const CallUs = memo(() => {

  const info = CONTACT_INFO[LANG]
  const message = CALL_US_TRANSLATIONS[LANG](info.email, info.tel)

  return (
    <P dangerouslySetInnerHTML={{ __html: message }} />
  )
})

const P = styled.p`
  ${presets.font26_1}
  color: var(--color-background);
  grid-column: 1 / span 5;
  letter-spacing: -.23px;
  margin-bottom: ${vw(50, 'mobile')};
  grid-row: 1;

  ${mq.greaterThan('tablet')} {
    grid-column: 2 / span 4;
    letter-spacing: -.3px;
    margin-bottom: ${vw(60, 'desktop')};
  }

  a {
    ${createUnderline({ reverse: true, color: 'white' })}

    &.en{
      ${createUnderline({ reverse: true, color: 'white' })}
    }
    &.phone {
      ${createUnderline({ color: 'orange', height: 3 })}
    }
  }

  .phone {
    ${presets.font53}
    color: var(--color-gold);
    display: inline-block;
    margin-top: ${vw(10, 'mobile')};

    ${mq.greaterThan('tablet')} {
      margin-top: ${vw(15, 'desktop')};
    }
  }
`
